import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import commitment from '../views/tempRecord/commitment.vue'
import peopleTemp from '../views/tempRecord/peopleTemp.vue'
import classTemp from '../views/tempRecord/classTemp.vue'
import historyPage from '../views/tempRecord/historyPage.vue'
import searchStuMsg from '../views/tempRecord/searchStuMsg.vue'
import dormitoryTemp from '../views/tempRecord/dormitoryTemp.vue'
import selectClass from '../views/tempRecord/selectClass.vue'
import tempGun from "../views/tempRecord/tempGun";

import killRecord from '../views/logRecord/killRecord.vue'
import virusRecord from '../views/logRecord/virusRecord.vue'

import manorStuDaily from '../views/daily/manorStuDaily.vue'
import manorTchDaily from '../views/daily/manorTchDaily.vue'
import schTchDaily from '../views/daily/schTchDaily.vue'
import schStuDaily from '../views/daily/schStuDaily.vue'
import classDaily from '../views/daily/classDaily.vue'
import killDaily from '../views/daily/killDaily.vue'
import tempArchives from '../views/tempRecord/tempArchives.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/commitment',
		name: 'commitment',
		component: commitment
	},
	{
		path: '/peopleTemp',
		name: 'peopleTemp',
		component: peopleTemp
	},
	{
		path: '/classTemp',
		name: 'classTemp',
		component: classTemp
	},
	{

		path: '/killRecord',
		name: 'killRecord',
		component: killRecord
	},
	{
		path: '/virusRecord',
		name: 'virusRecord',
		component: virusRecord,
		meta: {
			keepAlive: true, // false为不缓存
			isBack: false, //用于判断上一个页面是哪个
		}
	},
	{

		path: '/manorStuDaily',
		name: 'manorStuDaily',
		component: manorStuDaily
	},
	{

		path: '/manorTchDaily',
		name: 'manorTchDaily',
		component: manorTchDaily
	},
	{

		path: '/classDaily',
		name: 'classDaily',
		component: classDaily,
        meta: {
            keepAlive: true, // false为不缓存
            isBack: false, //用于判断上一个页面是哪个
        }
	},
	{
		path: '/schTchDaily',
		name: 'schTchDaily',
		component: schTchDaily

	},
	{
		path: '/schStuDaily',
		name: 'schStuDaily',
		component: schStuDaily
	},
	{
		path: '/killDaily',
		name: 'killDaily',
		component: killDaily
	},
	{
		path: '/selectClass',
		name: 'selectClass',
		component: selectClass
	},
	{
		path: '/historyPage',
		name: 'historyPage',
		component: historyPage,
		meta: {
			keepAlive: true, // false为不缓存
			isBack: false, //用于判断上一个页面是哪个
		}
	},
	{
		path: '/dormitoryTemp',
		name: 'dormitoryTemp',
		component: dormitoryTemp,
		meta: {
			keepAlive: true, // false为不缓存
			isBack: false, //用于判断上一个页面是哪个
		}
	},
	{
		path: '/searchStuMsg',
		name: 'searchStuMsg',
		component: searchStuMsg
	},
	{
		path: '/tempArchives',
		name: 'tempArchives',
		component: tempArchives
	},
    {
        path: '/tempGun',
        name: 'tempGun',
        component: tempGun
    }
];

const router = new VueRouter({
	routes
});

export default router
